var _circle, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgError = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.99984,
    cy: 6.99996,
    r: 5.83333,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57422 7.57422V4.07422H6.42578V7.57422H7.57422ZM7.57422 9.92578V8.75H6.42578V9.92578H7.57422ZM2.87109 2.89844C4.01953 1.75 5.39583 1.17578 7 1.17578C8.60417 1.17578 9.97135 1.75 11.1016 2.89844C12.25 4.02865 12.8242 5.39583 12.8242 7C12.8242 8.60417 12.25 9.98047 11.1016 11.1289C9.97135 12.2591 8.60417 12.8242 7 12.8242C5.39583 12.8242 4.01953 12.2591 2.87109 11.1289C1.74089 9.98047 1.17578 8.60417 1.17578 7C1.17578 5.39583 1.74089 4.02865 2.87109 2.89844Z",
    fill: "#FF0C3E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error.5b3e8f37.svg";
export { ForwardRef as ReactComponent };